import loadable from "@loadable/component";
import SwitchTab from "../../../components/Reusable/SwitchTab";
import APIS from "../../../constant/Endpoint";
import useDeleteHook from "../../../customHooks/useDeleteHook";
const CashReceiptComponent = loadable(
  () => import("../../../components/Transaction/Cash/CashReceipt/CashReceipt")
);
const CashReceipt = () => {
  const tabs = [
    {
      id: "cash-payment",
      label: "Cash Payment",
      href: "/accounting/cash-payment",
    },
    {
      id: "cash-receipt",
      label: "Cash Receipt",
      href: "/accounting/cash-receipt",
    },
  ];
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["cash-payment"],
  });

  const handleDelete = async (id: string, setOpenDeletePopup: any) => {
    const url = `${APIS.BILL}${id}/`;
    const formData = {};
    try {
      const res = await mutateAsync({ url, formData, setError: () => {} });
      if (res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <SwitchTab tabs={tabs} />
      <CashReceiptComponent handleDelete={handleDelete} isLoading={isLoading} />
    </div>
  );
};

export default CashReceipt;
